/** American odds display: prefix positive values with + */
export const formatOdds = (value) => {
  if (value == null || value === "") return "-";
  const n = Number(value);
  if (!Number.isFinite(n) || n === 0) return "-";
  return n > 0 ? `+${n}` : `${n}`;
};

/** Spread line display: prefix positive point values with + (e.g. +4.5). */
export const formatPoint = (value) => {
  if (value == null || value === "" || value === "-") return "-";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  if (n === 0) return "0";
  return n > 0 ? `+${n}` : `${n}`;
};

/** Over/Under side label for totals (Over → O, Under → U). */
export const getTotalSideAbbrev = (side) => {
  const normalized = String(side || "")
    .trim()
    .toLowerCase();
  if (normalized === "over" || normalized === "o") return "O";
  if (normalized === "under" || normalized === "u") return "U";
  return "";
};

/** Total line display: O 54.5 / U 54.5 — no + prefix (aligns with spread column). */
export const formatTotalPoint = (value, side) => {
  if (value == null || value === "" || value === "-") return "-";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);

  const numStr = n === 0 ? "0" : `${n}`;
  const abbrev = getTotalSideAbbrev(side);
  return abbrev ? `${abbrev} ${numStr}` : numStr;
};

/** Bet-slip line: spread uses +/- point; totals use O/U; h2h has no point. */
export const formatBetSlipPoint = (item) => {
  if (!item || item.type === "h2h") return null;
  const value = item.originalPoint ?? item.point;
  if (value == null || value === "" || value === "-") return "-";
  if (item.type === "totals") {
    return formatTotalPoint(value, item.pointType || item.teamName);
  }
  return formatPoint(value);
};
